<template>
  <div
    v-if="itemToDelete"
    class="modal default-modal is-active"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modal-title"
    aria-describedby="modal-description"
    @keydown.esc="$emit('close')"
  >
    <div
      class="modal-background"
      @click="$emit('close')"
    />
    <div class="modal-card">
      <header class="modal-card-head">
        <p
          id="modal-title"
          class="modal-card-title"
        >
          Excluir ação
        </p>
      </header>

      <section class="modal-card-body">
        <p
          id="modal-description"
          class="modal-message"
        >
          Tem certeza que deseja excluir
          <strong class="action-title">"{{ itemToDelete.title }}"</strong>?
        </p>
      </section>

      <footer class="modal-card-foot">
        <lila-button
          type="submit"
          title="Excluir"
          class="submit-buttons"
          :second-button="{
            type: 'button',
            title: 'Cancelar',
            class: 'dark-lilas'
          }"
          @custom-click-event="$emit('confirm')"
          @custom-click-cancel-event="$emit('close')"
        />
      </footer>
    </div>
  </div>
</template>

<script>
import Button from "@components/shared/button/Button.vue";

export default {
  name: "DeleteActionPopup",

  components: {
    "lila-button": Button
  },

  props: {
    itemToDelete: {
      type: Object,
      required: true
    }
  },

  emits: ["close", "confirm"]
};
</script>

<style scoped>
.modal-card-body {
  padding: 20px 24px;
}

.modal-message {
  font-size: 15px;
  line-height: 1.6;
  color: #4a4a4a;
  margin-bottom: 0;
  text-align: center;
}

.action-title {
  font-size: 15px;
  font-weight: 600;
  color: #363636;
  word-break: break-word;
}

.modal-card-foot {
  justify-content: center;
  padding: 16px 24px 24px;
}
</style>
